<template lang="pug">
.home-page
  Purchase(:buyHref="buyHref",:show="true")
  section.section.s1(@click.once="setVideoState", @touchstart.once="setVideoState")
    .sec-header
      h2.sec-title(data-aos="fade-up",data-aos-delay="200")
      p.sec-desc(data-aos="fade-up",data-aos-delay="400") 中英生词&nbsp&nbsp一扫而光
    // a.sec-btn(:href="buyHref",data-aos="fade-up",data-aos-delay="600")  立即购买
    .sec-video(data-aos="fade-up",data-aos-delay="700",ref="videoBox")
      video#video.video.video-js.vjs-big-play-centered.vjs-default-skin.vjs-fluid.vjs-poster(
        webkit-playsinline="true",playsinline="true",
        x5-video-player-type="h5-page")
        source(src="https://ydschool-video.nosdn.127.net/1574847524318pen.mp4",type="video/mp4")
      .play-btn(@click.stop="playVideo('click')",@touchstart.stop,v-show="playShow")
  section.section.s2
    .sec-header
      h2.sec-title(data-aos="fade-up",data-aos-delay="200") 即扫即译，大幅提升查词效率
      .sec-desc(data-aos="fade-up",data-aos-delay="400")
        p 1秒识别1个单词，
        p 查词速度是翻阅纸质词典的15倍
    .sec-part(data-aos="fade-up",data-aos-delay="500")
      .sec-chart
        img.sec-data(src="../assets/s2_data1.png",
          data-aos="fade",data-aos-delay="200",data-aos-duration="1500")
        img.sec-data(src="../assets/s2_data2.png",
          data-aos="fade",data-aos-delay="350",data-aos-duration="1500")
        img.sec-data(src="../assets/s2_data3.png",
          data-aos="fade",data-aos-delay="500",data-aos-duration="1500")
  section.section.s3
    .sec-header
      h2.sec-title(data-aos="fade-up",data-aos-delay="200")
         p 内置有道词典及专业考试词典
         p 收录150万词条
      .sec-desc(data-aos="fade-up",data-aos-delay="400")
        p 兼容绘本、教材、课外读物、报刊等海量印刷品，
        p 不限内容，随心任扫
        p 还支持SSAT、SAT、GRE、TOEFL、IELTS
        p 等专业考试词典查询，让查词更专业且有针对性
    .sec-part(data-aos="fade-up",data-aos-delay="500")
      .sec-pen(data-aos="fade",data-aos-duration="2000")
  section.section.s4
    .sec-header
      h2.sec-title(data-aos="fade-up",data-aos-delay="200") 真人发音  畅享纯正英/美音
      .sec-desc(data-aos="fade-up",data-aos-delay="400")
        p 仿佛拥有随身外教，
        p 助力培养正确发音习惯
    .sec-part(data-aos="fade-up",data-aos-delay="500")
  section.section.s5
    .sec-header
      h2.sec-title(data-aos="fade-up",data-aos-delay="200")
        p 多行扫描翻译
        p 让阅读顺畅感陡增
      .sec-desc(data-aos="fade-up",data-aos-delay="400")
        p 阅读英文原版书籍时
        p 无惧长句，换行扫扫也能翻
    .sec-part(data-aos="fade-up",data-aos-delay="500")
  section.section.s6
    .sec-header
      h2.sec-title(data-aos="fade-up",data-aos-delay="200") 有道神经网络翻译技术(YNMT)
      p.sec-desc(data-aos="fade-up",data-aos-delay="400")  翻译质量堪比专业八级
    .sec-part(data-aos="fade-up",data-aos-delay="500")
      .sec-res(data-aos="fade",data-aos-delay="1500",data-aos-duration="1800")
      .sec-res2(data-aos="fade",data-aos-delay="1000",data-aos-duration="1500")
  section.section.s7
    .sec-header
      h2.sec-title(data-aos="fade-up",data-aos-delay="200") AI语音助手 全方位智能交互
      .sec-desc(data-aos="fade-up",data-aos-delay="400")
        p 语音助手智能应答
        p 说话就能搜单词、查古诗、问天气
    .sec-part(data-aos="fade-up",data-aos-delay="500")
      .sec-bubble(data-aos="fade",data-aos-delay="1000",data-aos-duration="1800")
  section.section.s8
    .sec-header
      h2.sec-title(data-aos="fade-up") 多项贴心设计  智能  更全能
    .sec-part
      .sec-line(data-aos="slide-right",data-aos-delay="200")
        img.sec-img(src="../assets/s8_pen1.png")
        .sec-text
          .sec-part-title 灵敏触屏，护眼交互
          .sec-part-desc  标配高灵敏度电容触摸屏，采用深色护眼图标，全面提升视觉体验。
      .sec-line(data-aos="slide-left",data-aos-delay="350")
        .sec-text
          .sec-part-title 系统在线更新
          .sec-part-desc 终生持续更新，随时获取新版词典，享受最新功能。
        img.sec-img(src="../assets/s8_pen2.png")
      .sec-line(data-aos="slide-right",data-aos-delay="500")
        img.sec-img(src="../assets/s8_pen3.png")
        .sec-text
          .sec-part-title 蓝牙耳机
          .sec-part-desc 支持蓝牙功能，轻松连接蓝牙耳机
</template>

<script>
import enableInlineVideo from 'iphone-inline-video';
import Purchase from '@/components/Purchase.vue'
import posterImg from '@/assets/cover.jpg'

export default {
  name: 'home',
  data() {
    return {
      playShow: true,
      posterShow: true,
      buyHref: 'https://j.youzan.com/gXCsGY',
      tStart: '',
      timer: null,
      showPurchase: false,
      clicked: false,
      mPlayer: null,
    }
  },
  mounted() {
    document.addEventListener('scroll', this.debounce)
    // eslint-disable-next-line
    this.mPlayer = videojs(
      'video',
      {
        controls: true,
        preload: 'auto',
        poster: posterImg,
        muted: false,
        language: 'zh-CN',
        controlBar: {
          muteToggle: true,
          playToggle: true,
          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          volumePanel: false,
        },
      },
      () => {
        if (window.ydk.isIos) {
          const video = document.querySelector('video')
          enableInlineVideo(video)
        }
      },
    )
    this.mPlayer.on('play', this.canPlay)
  },
  methods: {
    canPlay() {
      console.log('canPlay')
      this.playShow = false
      this.mPlayer.off('play', this.canPlay)
    },
    setVideoState() {
      this.clicked = true
      this.playVideo()
    },
    playVideo(type) {
      console.log('play')
      if (type !== 'click') {
        this.mPlayer.muted(true)
      }
      this.mPlayer.play()
      if (this.posterShow) {
        this.mPlayer.on('timeupdate', this.hidePoster)
      }
    },
    hidePoster() {
      console.log('hidePoster')
      this.posterShow = false
      this.mPlayer.off('timeupdate', this.hidePoster)
    },
    debounce(e) {
      const height = window.innerHeight
      // eslint-disable-next-line
      var e = e || window.event;
      const delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
      const tCurr = +new Date();
      const mustRunDelay = 300
      const delay = 50
      clearTimeout(this.timer);
      if (!this.tStart) {
        this.tStart = tCurr;
      }

      if (tCurr - this.tStart >= mustRunDelay) {
        this.scroll(delta, height)
        this.tStart = tCurr;
      } else {
        this.timer = setTimeout(() => {
          this.scroll(delta, height)
        }, delay);
      }
    },
    scroll() {
      console.log('scroll')
      //      const documentScrollTop = document.documentElement.scrollTop
      //        || document.body.scrollTop
      //        || window.pageYOffset

      // this.showPurchase = documentScrollTop > 0
      const rects = this.$refs.videoBox.getBoundingClientRect()
      const TOP = 0
      if (!this.mPlayer.paused() && rects.top < TOP) {
        this.mPlayer.pause()
        return
      }
      if (this.clicked && this.mPlayer.paused() && rects.top > TOP) {
        console.log('scroll play')
        this.playVideo()
      }
    },
    destroyListener() {
      clearTimeout(this.timer)
      this.timer = null
      document.removeEventListener('scroll', this.debounce);
    },
  },
  components: {
    Purchase,
  },
  beforeDestroy() {
    this.destroyListener()
  },
}
</script>

<style lang="stylus">
  img
    pointer-events none
  .video-js
    background-color: transparent
    .vjs-big-play-button
      display: none
    &.vjs-ended
      .vjs-poster
        display: block
  .home-page
    font-family "PingFang SC"
    line-height 1
    padding-top 1.3rem
  .section
    width 100%
    background-color #fff
    color #30323a
  .sec-title
    margin 1.38rem auto 0.46rem
    font-size 0.6rem
    font-weight bold
    p + p
      margin-top 0.24rem
  .sec-desc
    font-size 0.36rem
  .sec-desc
    p + p
     margin-top 0.25rem
  .sec-part
    margin-top 0.94rem
  .s1
    height 19.38 rem
    background url(../assets/s1_bg.jpg) 0 0 / 100% 100% no-repeat
    padding-top 1.42rem
    box-sizing border-box
    .sec-title
      margin 0 auto 0.4rem
      width 8.32rem
      height 0.92rem
      background url(../assets/s1_title.png) 0 0 / 100% 100% no-repeat
    .sec-desc
      letter-spacing 5px
      font-size 0.48rem
      color rgb(48, 50, 58)
      margin-bottom 0.65rem
    .sec-btn
      display block
      margin 0 auto
      width 3.02rem
      line-height 0.93rem
      border-radius 0.46rem
      background-color rgb(216, 53, 53)
      color #fff
      font-size 0.43rem
    .sec-video
      position relative
      margin 0.94rem auto 0
      border-radius 0.2rem
      width 8.7rem
      height 4.89rem
      overflow hidden
      .video
        width 100%
        height 100%
        object-fit: cover
      .play-btn
        position absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
        width 1.39rem
        height 1.39rem
        background url(../assets/btn_paly.svg) 0 0 / contain no-repeat
  .sec-part
    position relative
    width 100%
    background 0 0/ 100% 100% #fff no-repeat
  .s2
    .sec-part
      height 11.73rem
      background-image url(../assets/s2_part.jpg)
    .sec-chart
      position absolute
      left 1.1rem
      bottom 0.4rem
      text-align left
    .sec-data
      display block
      height 0.75rem
      margin-bottom 0.79rem
    .sec-data:last-child
      height 0.88rem
      margin-bottom 0
  .s3
    .sec-part
      height 8.23rem
      background-image url(../assets/s3_part.jpg)
    .sec-pen
      position absolute
      bottom -1.3rem
      left 50%
      width 9.05rem
      margin-left -4.525rem
      height 2.16rem
      background url(../assets/s3_pen.png) 0 0 / 100% 100% no-repeat
  .s4
    padding-top 1rem
    .sec-part
      height 10.11rem
      background-image url(../assets/s4_part.jpg)
  .s5
    .sec-part
      height 10.89rem
      background-image url(../assets/s5_part.jpg)
  .s6
    .sec-part
      height 11.21rem
      background-image url(../assets/s6_part.jpg)
    .sec-res
      position absolute
      left 0.6rem
      top 1rem
      width 5.11rem
      height 4.15rem
      background url(../assets/s6_res1.png) 0 0 /contain no-repeat
      z-index 2
    .sec-res2
      position absolute
      width 4.34rem
      left 4.7rem
      top 1.3rem
      height 3.56rem
      background url(../assets/s6_res2.png) 0 0 /contain no-repeat
      z-index 1
  .s7
    .sec-part
      height 11.01rem
      background-image url(../assets/s7_part.jpg)
    .sec-bubble
      position absolute
      top 1.4rem
      left 0.5rem
      width 5.64rem
      height 1.74rem
      background url(../assets/s7_bubble.png) 0 0 / 100% 100% no-repeat
  .s8
    padding-bottom 0.94rem
    .sec-part
      width 8.73rem
      margin 0.9rem auto 0
    .sec-line
      display flex
    .sec-img
      flex 1
      width 50%
      height 4.36rem
    .sec-text
      flex 1
      align-self center
      padding 0 0.3rem
    .sec-part-title
      font-weight: bold
      font-size 0.33rem
      margin-bottom 0.37rem
    .sec-part-desc
      font-size 0.3rem
      line-height 1.5
</style>
